export const IS_MOBILE = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
